import React from 'react';
import { Video } from 'lucide-react';
import PageHeader from '@/components/common/PageHeader';
import MarketingVideoViewer from '@/components/marketing/MarketingVideoViewer';

const Marketing = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageHeader 
        title="ALPHA Marketing Video" 
        icon={Video}
        iconColor="text-primary"
      />
      
      <div className="container mx-auto px-4 py-8">
        <MarketingVideoViewer />
      </div>
    </div>
  );
};

export default Marketing;